<script setup lang="ts">
import clsx from 'clsx'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { betaPanelQuery, hasBetaPanelQuery } from '@/utils/panel-variant'

import DashboardMenu from '@/components/organisms/DashboardMenu.vue'

import ConfirmationModal from '@/components/organisms/ConfirmationModal.vue';

const props = defineProps<{
    id?: string
    noMarginTop?: boolean
}>()

const route = useRoute()
const router = useRouter()
const showBetaInvite = computed(() => !props.noMarginTop && !hasBetaPanelQuery(route.query))

function goBetaDashboard() {
    router.push({ name: 'dashboard', query: betaPanelQuery() })
}
</script>

<template>
    <div :id="id" class="w-screen h-screen overflow-y-scroll bg-[#FCFCFC]">
        <dashboard-menu @updateCategories="[]" />

        <div v-if="showBetaInvite" class="dashboard-beta-invite mt-[74px] px-4 pt-3">
            <button
                type="button"
                class="dashboard-beta-invite__button"
                aria-describedby="dashboard-beta-invite-description"
                @click="goBetaDashboard"
            >
                <span>Experimente o novo painel</span>
                <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    aria-hidden="true"
                >
                    <path d="M5 12h14m-6-6 6 6-6 6" />
                </svg>
            </button>
            <p id="dashboard-beta-invite-description" class="dashboard-beta-invite__description">
                Volte quando quiser em
                <strong>“Voltar ao painel clássico”.</strong>
            </p>
        </div>

        <div
            :class="clsx(
                'dashboard-layout__content px-4',
                showBetaInvite ? 'pt-3 pb-5' : 'py-5',
                !noMarginTop && !showBetaInvite && 'mt-[74px]',
            )"
        >
            <slot></slot>
        </div>

        <confirmation-modal />
    </div>
</template>

<style scoped>
.dashboard-beta-invite {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
}

.dashboard-beta-invite__button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    max-width: 100%;
    min-height: 34px;
    padding: 8px 14px;
    border-radius: 8px;
    background: var(--main-color);
    color: #fff;
    font-size: 12px;
    font-weight: 700;
    line-height: 18px;
    text-align: center;
    transition: filter 150ms ease;
}

.dashboard-beta-invite__button svg {
    flex-shrink: 0;
}

.dashboard-beta-invite__button:hover {
    filter: brightness(0.92);
}

.dashboard-beta-invite__button:focus-visible {
    outline: 2px solid var(--main-color);
    outline-offset: 3px;
}

.dashboard-beta-invite__description {
    margin: 0;
    color: #6b7280;
    font-size: 11px;
    line-height: 16px;
    text-align: center;
}

.dashboard-beta-invite__description strong {
    font-weight: 600;
}
</style>
